import { z } from 'zod'

export const tagPreviewSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const groupedTagsSchema = z.object({
  category: tagPreviewSchema.default({ id: '', name: '' }),
  subCategories: z.array(tagPreviewSchema),
  subSubCategories: z.array(tagPreviewSchema),
  amenities: z.array(tagPreviewSchema),
})

export const tagSchema = z.object({
  id: z.string(),
  name: z.string(),
  tagType: z.string(),
  parentId: z.string().nullable(),
})

export const tagListResponseSchema = z.array(tagSchema)

// Onboarding-flow response: just the ids of the curated tags. The client
// already has the full tag tree from `/api/tags/`, so re-shipping the same
// rows is wasted bytes. Resolution to (name, tagType, parentId) happens on
// the client by id lookup against the cached tree.
export const onboardingTagsResponseSchema = z.array(z.string().uuid())

export type TagPreview = z.infer<typeof tagPreviewSchema>
export type GroupedTags = z.infer<typeof groupedTagsSchema>
export type TagDto = z.infer<typeof tagSchema>
export type TagListResponse = z.infer<typeof tagListResponseSchema>
export type OnboardingTagsResponse = z.infer<typeof onboardingTagsResponseSchema>
